export default __webpack_public_path__ + "static/media/robot-animations.273357df.gif";